import { all, call, put, select, take, takeLatest } from "redux-saga/effects";
import { push } from "connected-react-router";
import * as authService from "../../services/auth.service";
import * as actions from "../actions/accountRecovery.actions";
import { toaster, toastTypes } from "../../components/Toasts/toaster";
import * as profileService from "../../services/profile.service";

export function* recoverAccountSaga(action) {
  try {
    const { user_data } = action.payload;
    yield put({ type: `${actions.RECOVER_ACCOUNT}_PENDING` });

    const result = yield call(authService.recoverAccountRequest, user_data);

    yield put({
      type: `${actions.RECOVER_ACCOUNT}_SUCCEEDED`,
      payload: result
    });

    const matchedAccounts = yield select(
      ({ accountRecovery }) => accountRecovery.matchedAccounts
    );

    if (matchedAccounts.length > 1) {
      yield put(push("/confirm-account-recovery"));
    } else {
      yield put({
        type: actions.SELECT_RECOVERY_ACCOUNT,
        payload: matchedAccounts[0]
      });
    }
  } catch (error) {
    yield put({ type: `${actions.RECOVER_ACCOUNT}_FAILED`, payload: error });
  }
}

export function* recoverAccountByEmailSaga(action) {
  try {
    yield put({ type: `${actions.RECOVER_ACCOUNT_BY_EMAIL}_PENDING` });

    const result = yield call(authService.recoverAccountByEmailRequest, {
      email: action.payload
    });

    yield put({
      type: `${actions.RECOVER_ACCOUNT_BY_EMAIL}_SUCCEEDED`,
      payload: result
    });

    yield put(push("/"));
    yield call(toaster, "passwordResetEmailSent");
  } catch (error) {
    yield put({
      type: `${actions.RECOVER_ACCOUNT_BY_EMAIL}_FAILED`,
      payload: error
    });
  }
}

export function* resetPasswordSaga(action) {
  try {
    console.log("resetPasswordSaga payload", action.payload);
    
    yield put({ type: `${actions.SET_NEW_PASSWORD}_PENDING` });

    const { recoveryMethod } = yield select(
      ({ accountRecovery }) => accountRecovery
    );

    const resetRequest =
      recoveryMethod === "text"
        ? authService.resetPasswordAfterCodeRequest
        : authService.resetPasswordRequest;

    const result = yield call(resetRequest, action.payload);

    yield put({
      type: `${actions.SET_NEW_PASSWORD}_SUCCEEDED`,
      payload: result
    });
    yield put(push("/"));
    yield call(toaster, "passwordReset");
  } catch (error) {
    console.log(error);
    yield put({ type: `${actions.SET_NEW_PASSWORD}_FAILED`, payload: error });
  }
}

export function* chooseRecoveryMethodSaga(action) {
  try {
    const { recoveryMethod } = action.payload;

    yield put({
      type: `${actions.CHOOSE_RECOVERY_METHOD}_SUCCEEDED`,
      payload: recoveryMethod
    });

    if (recoveryMethod === "email") {
      yield put(push("/account-recovery-by-email"));
    } else {
      const { validated_phone_number } = yield select(
        ({ accountRecovery }) => accountRecovery.selectedAccount
      );

      const payload = {
        phoneNumber: validated_phone_number,
        verificationType: "text"
      };

      const result = yield call(profileService.confirmPhoneNumber, payload);
      yield put(actions.setResetCodeAction(result.data.verificationCode));
      yield put(push("/account-recovery-by-text"));
    }
  } catch (error) {
    yield put({
      type: `${actions.CHOOSE_RECOVERY_METHOD}_FAILED`,
      payload: error
    });
  }
}

export function* confirmResetCodeSaga(action) {
  try {
    const { userEnteredCode } = action.payload.values;
    yield put({ type: `${actions.CONFIRM_RESET_CODE}_PENDING` });
    const { verificationCode } = yield select(state => state.accountRecovery);

    if (userEnteredCode == parseInt(verificationCode)) {
      yield put({ type: `${actions.CONFIRM_RESET_CODE}_SUCCEEDED` });
      yield put(push("/password-reset"));
    }
  } catch (error) {
    yield put(push("/"));
    yield put({
      type: `${actions.CONFIRM_RESET_CODE}_FAILED`,
      payload: error
    });
  }
}

export function* selectRecoveryAccountSaga(action) {
  try {
    yield put({ type: `${actions.SELECT_RECOVERY_ACCOUNT}_PENDING` });

    yield put({
      type: `${actions.SELECT_RECOVERY_ACCOUNT}_SUCCEEDED`,
      payload: action.payload
    });

    yield put(push("/account-recovery-method"));
  } catch (error) {
    yield put({
      type: `${actions.SELECT_RECOVERY_ACCOUNT}_FAILED`,
      payload: error
    });
  }
}

export function* watchRecoverAccountSaga() {
  yield takeLatest(actions.RECOVER_ACCOUNT, recoverAccountSaga);
}

export function* watchResetPasswordSaga() {
  yield takeLatest(actions.SET_NEW_PASSWORD, resetPasswordSaga);
}

export function* watchrecoverAccountByEmailSaga() {
  yield takeLatest(actions.RECOVER_ACCOUNT_BY_EMAIL, recoverAccountByEmailSaga);
}

export function* watchSelectRecoveryAccountSaga() {
  yield takeLatest(actions.SELECT_RECOVERY_ACCOUNT, selectRecoveryAccountSaga);
}

export function* watchChooseRecoveryMethodSaga() {
  yield takeLatest(actions.CHOOSE_RECOVERY_METHOD, chooseRecoveryMethodSaga);
}

export function* watchConfirmResetCodeSaga() {
  yield takeLatest(actions.CONFIRM_RESET_CODE, confirmResetCodeSaga);
}

export default function* accountRecoverySagas() {
  yield all([
    watchRecoverAccountSaga(),
    watchChooseRecoveryMethodSaga(),
    watchSelectRecoveryAccountSaga(),
    watchrecoverAccountByEmailSaga(),
    watchResetPasswordSaga(),
    watchConfirmResetCodeSaga()
  ]);
}



// WEBPACK FOOTER //
// ./src/redux/sagas/accountRecovery.sagas.js